import { useStore } from '@/store';

const store = useStore();

export default {
    sources: {
        'clere-raster': {
            type: 'raster',
            maxzoom: 25,
            tileSize: 256,
            url: 'mapbox://mapbox.satellite',
            bounds: [-180, -90, 180, 90],
        },
        clere: {
            type: 'vector',
            minzoom: 10,
            maxzoom: 20,
            url: `${store.state.clereTileserverUrl}/mapbox/tile/course/${store.getters.currentCourseSchema.id}/default.json`,
            bounds: [-1.745055, 52.55264, -1.727072, 52.565102],
        },
        grid_5yd: {
            type: 'vector',
            minzoom: 0,
            maxzoom: 25,
            tiles: [
                `${store.state.apiUrl}/mapbox/vector/course/${store.getters.currentCourseSchema.id}/grids/5/{z}/{x}/{y}.vector.pbf`,
            ],
        },
        pin: {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [0, 0],
                },
            },
        },
    },
    glyphs: 'mapbox://fonts/openmaptiles/{fontstack}/{range}.pbf',
    layers: {
        type: Array,
        default: () => [],
    },
};
